export default function (element, data) {
    element.addEventListener("click", function () {
        window.dispatchEvent(new Event("open_menu"));
    });
}
